import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import { SovrynnLogo } from '../Brand';
import '../../App.css';

const WelcomeStep = ({ onNext }) => {
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [termsError, setTermsError] = useState('');

  const handleGetStarted = () => {
    if (!termsAccepted) {
      setTermsError(
        'Please agree to the Terms of Service and Privacy Policy to continue',
      );
      return;
    }
    setTermsError('');
    onNext();
  };

  return (
    <div className="onboarding-content">
      <div className="welcome-content">
        <div className="onboarding-logo">
          <SovrynnLogo size="lg" />
        </div>
        <h2 className="welcome-title">Welcome to Sovrynn</h2>
        <p className="welcome-subtitle">Your operation. <span className="text-accent">Your intelligence.</span></p>
        <p className="welcome-description">
          Get set up in a few minutes. Sovrynn gives you the intelligence to run it right.
        </p>

        <ul className="welcome-checklist">
          <li>
            <span className="check-icon"><Check size={18} /></span>
            <span>Know your compliance score before the DOT does</span>
          </li>
          <li>
            <span className="check-icon"><Check size={18} /></span>
            <span>Never miss a document expiration again</span>
          </li>
          <li>
            <span className="check-icon"><Check size={18} /></span>
            <span>Stay compliance-verified without a compliance consultant</span>
          </li>
          <li>
            <span className="check-icon"><Check size={18} /></span>
            <span>Your operation, your data, your control</span>
          </li>
        </ul>

        <label className="onboarding-terms-agree">
          <input
            type="checkbox"
            checked={termsAccepted}
            onChange={(e) => {
              setTermsAccepted(e.target.checked);
              if (termsError) setTermsError('');
            }}
          />
          <span>
            I agree to the Sovrynn{' '}
            <Link to="/terms" target="_blank" rel="noopener noreferrer">
              Terms of Service
            </Link>{' '}
            and{' '}
            <Link to="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </Link>
          </span>
        </label>

        {termsError ? (
          <p className="onboarding-terms-error" role="alert">
            {termsError}
          </p>
        ) : null}

        <div className="onboarding-buttons welcome-buttons">
          <div></div>
          <button
            type="button"
            className="btn btn-primary btn-large"
            onClick={handleGetStarted}
            disabled={!termsAccepted}
          >
            Get Started →
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeStep;
